import { Box } from "@origin-digital/ods-core";
import { PopularArticlesSkeleton } from "../PopularArticles/PopularArticlesSkeleton";

export const SearchingSkeleton = (): JSX.Element => (
  <Box data-id="searching-skeleton" paddingY="medium">
    <PopularArticlesSkeleton />
  </Box>
);
